import I18nKeys from 'src/utils/i18n-keys/'
import Misc from 'src/utils/helper/misc'

export default {
  getfIdFromRoute () {
    const routeParams = this.$route?.params || {}

    return Misc.isValidValue(routeParams.id) ? routeParams.id : null
  },
  setNewTemplate (template = '') {
    // This removes styles on the contract template received from API. so that same could be set on frontend
    const styleTag = ['<style>', '</style>']
    const startIdx = template.indexOf(styleTag[0])
    const endIdx = template.indexOf(styleTag[1]) + styleTag[1].length
    const newTemplate = template.slice(0, startIdx) + template.slice(endIdx)
    return newTemplate
  },
  getCountries () {
    return I18nKeys.COUNTRIES.map(iso => {
      return {
        value: iso,
        name: this.$t('data.countries.' + [iso])
      }
    })
  },
  setCountries () {
    this.country.setOptions({
      obj: this.getCountries(),
      value: 'value',
      name: 'name',
      multiple: true
    })
  },
  setIbCountries () {
    this.ibcountry.setOptions({
      obj: this.getCountries(),
      value: 'value',
      name: 'name',
      multiple: true
    })
  },
  getStates (isoCountry) {
    return I18nKeys.STATES[isoCountry].map(iso => {
      return {
        value: iso,
        name: this.$t('data.states.' + [iso])
      }
    })
  }
}
